<template>
    <el-row>
        <el-row class="bottom20">
            <el-table :data="page.records" :row-class-name="getVisitedRowClassName" :cell-class-name="getSelectedCellClassName">
                <el-table-column prop="code">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">编码</span><br/>
                        <div>
                            <el-input v-model="pageSearch.search.like_code" size="mini">
                            </el-input>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>
                            <a href="javascript:void(0);" @click="toDetailShow(scope.row)">{{scope.row.code}}</a>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="name">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">组名</span><br/>
                        <div>
                            <el-input v-model="pageSearch.search.like_name" size="mini">
                            </el-input>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>
                            {{scope.row.name}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status">
                    <template slot="header" slot-scope="scope">
                        <span v-if="scope != null">状态</span><br/>
                        <div>
                            <el-select v-model="pageSearch.search.eq_status" :clearable="true" size="mini" class="width100">
                                <el-option :value="1" :label="'启用'">
                                </el-option>
                                <el-option :value="0" :label="'停用'">
                                </el-option>
                            </el-select>
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <span>
                            <el-tag :type="String(scope.row.status) === '1' ? 'success' : 'danger'">
                                {{scope.row.status === 1 ? '启用' : scope.row.status === 0 ? '停用' : scope.row.status}}
                            </el-tag>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @current-change="setPageSearchCurrent"
                    @size-change="setPageSearchSize"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </el-row>
</template>

<script>
    import eventBus from "@/util/common/event-bus";

    import {
        EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID,
        EVENT_KEY$$PAGE$$QUERY,
        EVENT_KEY$$PAGE$$REMOVE_VISITED_ID,
        EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID,
        OPERATION_SHOW,
        PATH_DETAILS,
    } from './common';
    import DcimServer from "@/api/dcim";

    export default {
        name: "equipment-group-page",
        props: {
            itemId: {},
            searchByItem: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                currentRowId: null,
                visitedIds: [],
                pageSearch: {
                    current: 0,
                    size: 10,
                    search: {
                        like_code: null,
                        like_name: null,
                        eq_status: 1,
                    },
                },
                page: {
                    total: 0,
                    records: [],
                },

                eventKeyIds: {},
            };
        },
        watch: {
            itemId: {
                immediate: true,
                handler() {
                    if (this.searchByItem) {
                        this.reQueryByPage();
                    }
                },
            },
            'pageSearch.current': {
                deep: false,
                immediate: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                immediate: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'pageSearch.search': {
                deep: true,
                immediate: false,
                handler(search) {
                    this.reQueryByPage();
                    if (search != null) {
                        //
                    }
                }
            },
            'page': {
                deep: true,
                immediate: false,
                handler(page) {
                    this.setPage(page);
                    if (page.total > 0) {
                        let record;
                        let records = page.records;
                        if (this.currentRowId != null) {
                            for (let i = 0, l = records.length; i < l; i++) {
                                if (this.currentRowId === records[i][this.id]) {
                                    record = records[i];
                                    break;
                                }
                            }
                        }
                        if (record == null) {
                            record = records[0];
                        }
                        this.select(record);
                    }
                },
            },
        },
        methods: {
            setPageSearchCurrent(current) {
                this.pageSearch.current = current;
            },
            setPageSearchSize(size) {
                this.pageSearch.size = size;
            },
            setPage(page) {
                this.page = page;
            },
            setCurrentRowId(currentRowId) {
                this.currentRowId = currentRowId;
                eventBus.trigger(EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID, currentRowId);
            },
            addVisitedId(currentRowId) {
                if (currentRowId != null) {
                    let visitedIds = this.visitedIds;
                    let existed = false;
                    for (let i = 0, len = visitedIds.length; i < len; i++) {
                        if (visitedIds[i] === currentRowId) {
                            existed = true;
                            break;
                        }
                    }
                    if (!existed) {
                        visitedIds.push(currentRowId);
                    }
                }
            },
            removeVisitedId(currentRowId) {
                if (currentRowId != null) {
                    let visitedIds = this.visitedIds;
                    let index = -1;
                    for (let i = 0, len = visitedIds.length; i < len; i++) {
                        if (visitedIds[i] === currentRowId) {
                            index = i;
                            break;
                        }
                    }
                    if (index > -1) {
                        visitedIds.splice(index, 1);
                    }
                }
            },
            select(data) {
                this.setCurrentRowId(data.id);
            },
            getSelectedCellClassName({row}) {
                let cellClassName = '';
                if (this.currentRowId === row.id) {
                    cellClassName += ' currentAccess ';
                }
                return cellClassName;
            },
            getVisitedRowClassName({row}) {
                let rowClassName = '';
                if (this.visitedIds.indexOf(row.id) !== -1) {
                    rowClassName += ' visited';
                }
                return rowClassName;
            },
            async doQueryByPage(pageSearch) {
                return DcimServer.equipmentGroup.page(pageSearch);
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.setPageSearchCurrent(1);
                }
            },
            async queryByPage() {
                let page = {total: 0, records: []};
                let pageSearch = JSON.parse(JSON.stringify(this.pageSearch));
                let searchByItem = this.searchByItem;
                let itemId = this.itemId;
                if (searchByItem) {
                    if (itemId != null && itemId !== '') {
                        let groups = await DcimServer.equipmentGroup.findByItemId(itemId);
                        let groupIds = groups.map(e => e.id);
                        if (groupIds != null && groupIds.length > 0) {
                            pageSearch.search.in_id = groupIds;
                            page = await this.doQueryByPage(pageSearch);
                        }
                    }
                } else {
                    page = await this.doQueryByPage(pageSearch);
                }
                if (page.records.length === 0 && this.pageSearch.current > 1) {
                    this.setPageSearchCurrent(this.pageSearch.current - 1);
                } else {
                    this.setPage(page);
                }
                return Promise.resolve(page);
            },
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            clearPageSearch() {
                this.pageSearch = {
                    current: 0,
                    size: 10,
                    search: {
                        like_code: null,
                        like_name: null,
                        eq_status: 1,
                    },
                };
            },
            toDetailShow(data) {
                this.select(data);
                this.addVisitedId(data.id);
                this.$router.push({path: PATH_DETAILS, query: {operation: OPERATION_SHOW, id: data.id}});
            },
        },
        mounted() {
            this.eventKeyIds[EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID] =
                eventBus.bind(EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID, {
                    next: (currentRowId) => {this.setCurrentRowId(currentRowId);}
                });

            this.eventKeyIds[EVENT_KEY$$PAGE$$QUERY] =
                eventBus.bind(EVENT_KEY$$PAGE$$QUERY, {
                    next: () => {this.query();}
                });
            this.eventKeyIds[EVENT_KEY$$PAGE$$REMOVE_VISITED_ID] =
                eventBus.bind(EVENT_KEY$$PAGE$$REMOVE_VISITED_ID, {
                    next: (currentRowId) => {this.removeVisitedId(currentRowId);}
                });

            this.query();
        },
        beforeDestroy() {
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$PAGE$$SET_CURRENT_ROW_ID]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$PAGE$$QUERY]);
            eventBus.unbind(this.eventKeyIds[EVENT_KEY$$PAGE$$REMOVE_VISITED_ID]);
        },
    }
</script>

<style scoped>

</style>
